import { UrlPathPrefix } from '@schedulelab/types/url';

export function buildCdnImageUrl(path: UrlPathPrefix): string {
  return `https://s3.us-east-2.amazonaws.com/schedulelab.io/public/images${path}`;
}
